var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// src/infrastructure/config/msalConfig.ts
// Login de operadores con Entra ID (US-BOE-09). MSAL obtiene un access token de Entra que
// Security canjea por el JWT de backoffice; ese token solo viaja al canje.
// Wiki: "Login de operadores del Backoffice con Entra ID", §3.1, §3.3 y §8.2.
// Nunca se registra ningún token en los logs, ni entero ni truncado.
import { PublicClientApplication } from '@azure/msal-browser';
import { env } from './env';
import { logger } from '../../utils/logger';
var LOGIN_MODES = ['password', 'both', 'entra'];
var readEntraSettings = function () {
    var _a, _b, _c, _d, _e, _f;
    return ({
        clientId: (_b = (_a = env.REACT_APP_ENTRA_CLIENT_ID) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '',
        tenantId: (_d = (_c = env.REACT_APP_ENTRA_TENANT_ID) === null || _c === void 0 ? void 0 : _c.trim()) !== null && _d !== void 0 ? _d : '',
        scope: (_f = (_e = env.REACT_APP_ENTRA_SCOPE) === null || _e === void 0 ? void 0 : _e.trim()) !== null && _f !== void 0 ? _f : '',
    });
};
// Solo el código de error de MSAL: el resto del objeto no se lleva a los logs.
var describeMsalError = function (error) { return (error === null || error === void 0 ? void 0 : error.errorCode) || 'unknown'; };
var resolveLoginMode = function () {
    var _a;
    var requested = ((_a = env.REACT_APP_BACKOFFICE_LOGIN_MODE) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) || 'password';
    if (!LOGIN_MODES.includes(requested)) {
        logger.warn("\u26A0\uFE0F Modo de login desconocido (".concat(requested, "); se usa 'password'."));
        return 'password';
    }
    if (requested === 'password') {
        return 'password';
    }
    var _b = readEntraSettings(), clientId = _b.clientId, tenantId = _b.tenantId, scope = _b.scope;
    if (!clientId || !tenantId || !scope) {
        logger.warn("\u26A0\uFE0F El modo de login '".concat(requested, "' necesita REACT_APP_ENTRA_CLIENT_ID, ") +
            "REACT_APP_ENTRA_TENANT_ID y REACT_APP_ENTRA_SCOPE; se usa 'password'.");
        return 'password';
    }
    return requested;
};
// Se resuelven en el primer uso (no al cargar el módulo) para no depender del orden de imports.
var loginMode;
var msalInstance = null;
var redirectResult = null;
/** Modo de login del entorno. Sin REACT_APP_BACKOFFICE_LOGIN_MODE, 'password'. */
export var getLoginMode = function () {
    if (!loginMode) {
        loginMode = resolveLoginMode();
    }
    return loginMode;
};
export var getEntraScopes = function () { return [readEntraSettings().scope]; };
export var buildMsalConfiguration = function () {
    var _a = readEntraSettings(), clientId = _a.clientId, tenantId = _a.tenantId;
    // Caché: la de por defecto de MSAL (sessionStorage). No se pasa a localStorage (wiki §6.2).
    return {
        auth: {
            clientId: clientId,
            authority: "https://login.microsoftonline.com/".concat(tenantId),
            redirectUri: "".concat(window.location.origin, "/login"),
        },
    };
};
/**
 * Inicializa MSAL y resuelve la vuelta del redirect de Entra. index.tsx la llama una vez,
 * antes del primer render. En modo 'password' no hace nada. Nunca rechaza.
 */
export var initializeMsal = function () { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (getLoginMode() === 'password') {
                    return [2 /*return*/];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                msalInstance = new PublicClientApplication(buildMsalConfiguration());
                return [4 /*yield*/, msalInstance.initialize()];
            case 2:
                _a.sent();
                return [4 /*yield*/, msalInstance.handleRedirectPromise()];
            case 3:
                redirectResult = _a.sent();
                if (redirectResult === null || redirectResult === void 0 ? void 0 : redirectResult.account) {
                    msalInstance.setActiveAccount(redirectResult.account);
                }
                return [3 /*break*/, 5];
            case 4:
                error_1 = _a.sent();
                logger.error('❌ Error al inicializar MSAL:', describeMsalError(error_1));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var getMsalInstance = function () { return msalInstance; };
/**
 * Devuelve el resultado del redirect de Entra una sola vez y lo olvida: así el canje no se
 * repite aunque StrictMode ejecute dos veces los efectos de la pantalla de login.
 */
export var takeEntraRedirectResult = function () {
    var result = redirectResult;
    redirectResult = null;
    return result;
};
/**
 * Access token de Entra para renovar la sesión sin interacción. Devuelve null si MSAL no
 * tiene cuenta en su caché (p. ej. en una pestaña nueva, porque la caché es de sessionStorage).
 * Propaga InteractionRequiredAuthError cuando Entra pide volver a autenticarse.
 */
export var acquireEntraAccessToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var account, result;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                account = (_a = msalInstance === null || msalInstance === void 0 ? void 0 : msalInstance.getActiveAccount()) !== null && _a !== void 0 ? _a : msalInstance === null || msalInstance === void 0 ? void 0 : msalInstance.getAllAccounts()[0];
                if (!msalInstance || !account) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, msalInstance.acquireTokenSilent({
                        scopes: getEntraScopes(),
                        account: account,
                    })];
            case 1:
                result = _b.sent();
                return [2 /*return*/, result.accessToken];
        }
    });
}); };
/**
 * Logout local: borra la caché de MSAL sin navegar al logout de Entra, así que no cierra la
 * sesión de Office 365 del navegador (wiki §2.3, regla 12).
 */
export var clearEntraSession = function () {
    msalInstance === null || msalInstance === void 0 ? void 0 : msalInstance.logoutRedirect({ onRedirectNavigate: function () { return false; } }).catch(function (error) {
        logger.warn('⚠️ No se ha podido limpiar la caché de MSAL:', describeMsalError(error));
    });
};
